// extracted by mini-css-extract-plugin
export default {"header":"Table_header__Gj7YL","link":"Table_link__E4+Ed","active":"Table_active__qJQ+S","inactive":"Table_inactive__Vl-8J","td":"Table_td__CMjWr","search":"Table_search__pZWtl"};